// VistaSemana.js
import React from "react";
import moment from "moment";

const VistaSemana = ({ events, currentDate }) => {
  const startOfWeek = moment(currentDate).startOf("week");
  const days = Array.from({ length: 7 }, (_, i) =>
    startOfWeek.clone().add(i, "days")
  );
  const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);

  // Mapeo de colores de fondo a colores de texto más oscuros
  const colorMapping = {
    "#e0e7ff": "#6366F1", // Morado claro -> Morado fuerte
    "#ede9fe": "#7C3AED", // Púrpura -> Púrpura oscuro
    "#bae6fd": "#0284C7", // Azul cielo -> Azul fuerte
    "#a7f3d0": "#059669", // Verde esmeralda -> Verde oscuro
    "#fecaca": "#DC2626", // Rojo claro -> Rojo fuerte
    "#fef9c3": "#A16207", // Amarillo claro -> Amarillo oscuro
  };

  // Función para obtener estilos base según el resource
  const getBackground = (event) => {
    switch (event.resource) {
      case "cotizacion":
        return "px-3 py-1 w-[120px] text-xs bg-blue-100 text-blue-400 rounded-sm flex justify-center items-center";
      case "evento":
        return "px-3 py-1 w-[120px] text-xs bg-green-100 text-green-500 rounded-sm flex justify-center items-center";
      case "festivo":
        return "px-3 py-1 w-[120px] text-xs bg-red-100 text-red-500 rounded-sm flex justify-center items-center";
      case "tarea":
        // No definimos bg en la clase, ya que usaremos el inline style con el color almacenado
        return "px-3 py-1 w-[120px] text-xs rounded-sm flex justify-center items-center";
      default:
        return "bg-gray-200";
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Columna de horas */}
      <div className="grid grid-cols-8 flex-1 border-t">
        <div className="border-r bg-gray-100">
          {hours.map((hour) => (
            <div
              key={hour}
              className="h-16 flex items-center justify-center text-gray-500 text-sm border-b"
            >
              {hour}
            </div>
          ))}
        </div>

        {/* Días de la semana */}
        {days.map((day) => {
          const dayEvents = events.filter((event) =>
            moment(event.start).isSame(day, "day")
          );
          return (
            <div key={day} className="flex flex-col border-r">
              {/* Encabezado del día */}
              <div className="h-16 flex items-center justify-center bg-gray-100 text-gray-700 font-semibold border-b">
                <span className="text-md uppercase">{day.format("ddd")}</span>
                <span className="text-md ml-2">{day.format("DD")}</span>
              </div>

              {/* Celdas de horas y eventos */}
              <div className="flex-1 relative">
                {hours.map((hour, hourIndex) => (
                  <div
                    key={`${day.format("DD-MM")}-${hour}`}
                    className="h-16 border-b relative flex items-start justify-center"
                  >
                    {dayEvents
                      .filter(
                        (event) => moment(event.start).hour() === hourIndex
                      )
                      .map((event) => {
                        const textColor =
                          event.resource === "tarea"
                            ? colorMapping[event.color] || "#1F2937" // Color de texto basado en el fondo
                            : "";

                        return (
                          <div
                            key={event.id}
                            className={`absolute rounded-sm text-xs font-bold ${getBackground(
                              event
                            )}`}
                            style={{
                              top: "50%",
                              transform: "translateY(-50%)",
                              padding: "4px 16px",
                              fontSize: "14px",
                              minWidth: "100px",
                              height: "40px",
                              // Para tareas se asigna el color seleccionado
                              backgroundColor:
                                event.resource === "tarea" ? event.color : undefined,
                              color: textColor,
                            }}
                          >
                            <p className="text-center">
                              {event.resource === "tarea"
                                ? event.category || "Sin categoría"
                                : event.title}
                            </p>
                          </div>
                        );
                      })}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VistaSemana;
